export enum DataBreachAction{
	OPEN_CLOSE = 'OPEN_CLOSE',
}
